import { render, staticRenderFns } from "./AddressUser.vue?vue&type=template&id=0255747a&"
import script from "./AddressUser.vue?vue&type=script&lang=js&"
export * from "./AddressUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports